<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number"><a id="page-3"></a><span href="#/toc#toc-chapter002" title="Link target outside of Sample">Chapter 2</span></h1>
<h1 class="chapter-title"><span href="#/toc#toc-chapter002" title="Link target outside of Sample">One Door Closes, Another Opens</span></h1>
<p class="noindent">Later, in circumstances that Sharon Li would certainly have frowned upon, the entire balance of reality is about to be pushed off the bungee.</p>
<p class="space-break">Soft cloth drags on carpet.</p>
<p>A door closes in the night.</p>
<p>Flicker of shadow across a door.</p>
<p>Sound of falling.</p>
<p>She says, “They’ll find you they’ll find you you have to get out now!”</p>
<p>Her voice is a gabble of forced breath, sandpaper in the throat, glass in the lungs.</p>
<p>A finger of wind commanding silence.</p>
<p>“Oh God.”</p>
<p>A brush of something soft against rapidly cooling skin, a whisper of sound that has no words, nor has ever felt the need.</p>
<p>“Let me live.”</p>
<p>Paper stirs across the floor.</p>
<p>Something…</p>
<p>… changes.</p>
<p>She says, “No. That isn’t what I—”</p>
<p>And she dies.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter002.vue?0a63b352